import { BaseModel } from '../../_base/crud';

export class PatientDevice extends BaseModel {
  alerts: any;
  date_last_sync: any;
  device_id: number;
  device_inventory_id: number;
  device_name: string;
  form_id: number;
  last_battery_value: number;
  patient_range: string;
  patient_range_id: number;
  patient_vitals_dto: any;
  serial_id: string;
}
